import { formatToTitleCase } from './format-to-title-case';
import { professionalDisplayName } from './professional-name';

interface AppointmentEntitySource {
  professional?: { honorific: string; name: string; avatar?: string } | null;
  partner?: { socialName: string; avatar?: string } | null;
}

export interface AppointmentEntity {
  name: string;
  avatar?: string;
  isProfessional: boolean;
}

export function partnerDisplayName(partner: { socialName: string; facility?: { name?: string } }): string {
  return partner.facility?.name ? `${partner.socialName} - ${partner.facility.name}` : partner.socialName;
}

export function resolveAppointmentEntity(source: AppointmentEntitySource): AppointmentEntity | null {
  if (source.professional) {
    return {
      name: professionalDisplayName(source.professional),
      avatar: source.professional.avatar,
      isProfessional: true,
    };
  }

  if (source.partner) {
    return {
      name: formatToTitleCase(source.partner.socialName),
      avatar: source.partner.avatar,
      isProfessional: false,
    };
  }

  return null;
}
